import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import { BUDGET_MODE } from '@/constants'

dayjs.extend(utc)
dayjs.extend(timezone)

export default {
  computed: {
    etcToUTC() {
      return tz => (tz ? tz.replace(/^Etc\/GMT([+-])(\d+)$/, (_, s, n) => `UTC${s === '-' ? '+' : '-'}${n}`) : '')
    },
  },

  methods: {
    getCampaignType(campaign) {
      if (!campaign.is_smart_performance_campaign && campaign.campaign_automation_type === 'MANUAL') {
        return 'Manual'
      }
      if (!campaign.is_smart_performance_campaign && campaign.campaign_automation_type === 'UPGRADED_SMART_PLUS') {
        return 'S++'
      }
      if (campaign.is_smart_performance_campaign && campaign.campaign_automation_type === 'SMART_PLUS') {
        return 'S+'
      }
      return 'Unknown'
    },

    getBudgetType(value) {
      switch (value) {
        case BUDGET_MODE.BUDGET_MODE_DYNAMIC_DAILY_BUDGET:
          return 'Daily, Campaign budget'
        case BUDGET_MODE.BUDGET_MODE_DAY:
          return 'Daily, Campaign budget optimization'
        case BUDGET_MODE.BUDGET_MODE_INFINITE:
          return ''
        case BUDGET_MODE.BUDGET_MODE_TOTAL:
          return 'Total, Campaign budget'
        default:
          return value
      }
    },

    convertTextDay(day) {
      switch (day) {
        case 'ZERO_DAY':
          return 'Day 0'
        case 'SEVEN_DAYS':
          return 'Day 7'
        default:
          return ''
      }
    },

    convertTextBid(adGroup) {
      if (adGroup?.optimizationGoal === 'VALUE') {
        return {
          label: 'Target ROAS',
          textDescription: adGroup.optimizationEvent === 'AD_REVENUE_VALUE' ? `Ad Revenue Value ${this.convertTextDay(adGroup.vboWindow)}` : `Purchase Value ${this.convertTextDay(adGroup.vboWindow)}`,
        }
      }
      if (adGroup?.optimizationGoal === 'IN_APP_EVENT') {
        return {
          label: 'Target CPA',
          textDescription: `USD/${this.convertOptimizationEvent(adGroup.optimizationEvent)}`,
        }
      }
      if (adGroup?.optimizationGoal === 'INSTALL') {
        return {
          label: 'Target CPA',
          textDescription: 'USD/Install',
        }
      }
      if (adGroup?.optimizationGoal === 'CLICK') {
        return {
          label: 'Target CPA',
          textDescription: 'USD/Click',
        }
      }
      if (adGroup?.optimizationGoal === 'LEAD_GENERATION') {
        return {
          label: 'Target CPA',
          textDescription: 'USD/Lead',
        }
      }
      if (adGroup?.optimizationGoal === 'CONVERT') {
        return {
          label: 'Target CPA',
          textDescription: 'USD/Conversion',
        }
      }
      if (adGroup?.optimizationGoal === 'TRAFFIC_LANDING_PAGE_VIEW') {
        return {
          label: 'Landing Page View',
          textDescription: 'Maximum Delivery',
        }
      }
      return ''
    },

    convertOptimizationEvent(value) {
      switch (value) {
        case 'ACTIVE':
          return 'Install'
        case 'ACTIVE_PAY':
          return 'Purchase'
        case 'ACTIVE_REGISTER':
          return 'Registration'
        case 'ADD_TO_WISHLIST':
          return 'Add to Wishlist'
        case 'COMPLETE_TUTORIAL':
          return 'Complete Tutorial'
        case 'CREATE_GAMEROLE':
          return 'Create Role'
        case 'CREATE_GROUP':
          return 'Create Group'
        case 'IN_APP_AD_CLICK':
          return 'In-App Ad Click'
        case 'IN_APP_AD_IMPR':
          return 'In-App Ad Impression'
        case 'IN_APP_CART':
          return 'Add to Cart'
        case 'IN_APP_DETAIL_UV':
          return 'View Content'
        case 'JOIN_GROUP':
          return 'Join Group'
        case 'LAUNCH_APP':
          return 'Launch App'
        case 'LOAN_COMPLETION':
          return 'Loan Disbursement'
        case 'LOGIN':
          return 'Login'
        case 'NEXT_DAY_OPEN':
          return 'Day 1 Retention'
        case 'RATE':
          return 'Rate'
        case 'SALES_LEAD':
          return 'Generate Lead'
        case 'SEARCH':
          return 'Search'
        case 'SPEND_CREDITS':
          return 'Spend Credit'
        case 'UNLOCK_ACHIEVEMENT':
          return 'Unlock Achievement'
        case 'UPDATE_LEVEL':
          return 'Achieve Level'
        case 'ADD_BILLING':
          return 'Add Payment Info'
        case 'BUTTON':
          return 'Click Button'
        case 'CONSULT':
          return 'Consult'
        case 'DOWNLOAD_START':
          return 'Download'
        case 'FORM':
          return 'Lead'
        case 'INITIATE_ORDER':
          return 'Initiate Checkout'
        case 'ON_WEB_ADD_TO_WISHLIST':
          return 'Add to Wishlist'
        case 'ON_WEB_CART':
          return 'Add to Cart'
        case 'ON_WEB_DETAIL':
          return 'View Content'
        case 'ON_WEB_ORDER':
          return 'Place an Order'
        case 'ON_WEB_REGISTER':
          return 'Complete Registration'
        case 'ON_WEB_SEARCH':
          return 'Search'
        case 'ON_WEB_SUBSCRIBE':
          return 'Subscribe'
        case 'SHOPPING':
          return 'Purchase'
        default:
          return ''
      }
    },
  },
}
